import { render, staticRenderFns } from "./stat_riversoft.vue?vue&type=template&id=01284acc&"
import script from "./stat_riversoft.vue?vue&type=script&lang=js&"
export * from "./stat_riversoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports